<template>
  <div>
    <header class="modal-header">
      <h3 class="modal-title">{{mode + ' User Services'}}</h3>
    </header>
    <div class="modal-body">
      <b-form>
        <b-form-group
          label="CODE:"
          label-for="code"
          v-show="mode === 'Edit'">
          <b-form-input
            id="code"
            type="text"
            v-model="userService.CODE"
            required>
          </b-form-input>
        </b-form-group>
        <b-form-group
          label="NAME:"
          label-for="name">
          <b-form-input
            id="name"
            type="text"
            v-model="userService.NAME"
            required>
          </b-form-input>
        </b-form-group>
        <b-form-group
          label="URL:"
          label-for="url">
          <b-form-input
            id="url"
            type="text"
            v-model="userService.URL"
            required>
          </b-form-input>
        </b-form-group>
        <b-form-group
          label="STATUS:"
          label-for="status">
          <c-switch
            color="success"
            variant="pill"
            size="lg"
            v-model="userService.STATUS"
            :checked="getStatus" />
        </b-form-group>
      </b-form>
    </div>
    <footer class="modal-footer">
      <b-btn :size="'sm'" @click="$emit('close')">Cancel</b-btn>
      <b-btn :variant="'primary'" :size="'sm'" @click="handleSubmit" :disabled="isFetching">{{mode === 'Add' ? 'Add' : 'Update'}}</b-btn>
    </footer>
  </div>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'
import server from '@/services/server'

export default {
  name: 'user-services-modal',
  props: {
    mode: String,
    model: Object
  },
  data () {
    return {
      userService: { ...this.model } || {},
      isFetching: false
    }
  },
  components: {
    cSwitch
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.isFetching = true
      let payload = {
        mode: this.mode,
        reqBody: [{
          code: this.userService.CODE,
          name: this.userService.NAME,
          url: this.userService.URL,
          status: this.getStatus ? 1 : 0
        }]
      }

      this.$store.dispatch('userService/upsertItem', payload).then(
        resp => this.$emit('close'),
        err => this.$emit('close')
      )
    }
  },
  computed: {
    getStatus () {
      if (this.userService) {
        return this.userService.STATUS ? true : false
      } else {
        return false
      }

    }
  }
}
</script>
